import {internalApi} from "../../../common/axios";
import {useMutationBase, useQueryBase} from "../../../shared/hooks/useHookBase";

// 4-1. 트로피 챌린지
const fetchTrophyChallenge = async () => {
    const {data} = await internalApi.get('trophy_challenge');
    return data.rows;
};

export const useTrophyChallenge = () => {
    return useQueryBase(['trophyChallenge'], fetchTrophyChallenge, {staleTime: 0});
};

const changeOnOff = async ({trophyId, onOff}) => {
    await internalApi.post('trophy_challenge/onoff', {trophyId, onOff});
};

export const useChangeTrophyChallengeOnOff = () => {
    return useMutationBase('trophyChallenge', changeOnOff);
};

// 4-2-1. 챌린지 그룹 관리
const fetchTrophyChallengeGroup = async () => {
    const {data} = await internalApi.get('trophy_challenge/group');
    return data.rows;
};

export const useTrophyChallengeGroup = () => {
    return useQueryBase(['trophyChallengeGroup'], fetchTrophyChallengeGroup, {staleTime: 0});
};

const fetchResourceList = async () => {
    const {data} = await internalApi.get('trophy_challenge/resource_list');
    return data.indexes;
};

export const useTrophyChallengeResourceList = () => {
    return useQueryBase(['trophyChallengeResourceList'], fetchResourceList, {staleTime: 0});
};

// 4-2-2. 챌린지 미션 그룹 관리 (모든 행 반환 → 프론트에서 groupIdx 기준 그룹화)
const fetchTrophyChallengeMissionGroup = async () => {
    const {data} = await internalApi.get('trophy_challenge/mission_group');
    return data.rows;
};

export const useTrophyChallengeMissionGroup = () => {
    return useQueryBase(['trophyChallengeMissionGroup'], fetchTrophyChallengeMissionGroup, {staleTime: 0});
};

// Event_Reward 목록
const fetchEventRewardList = async () => {
    const {data} = await internalApi.get('trophy_challenge/event_reward_list');
    return data.list;
};

export const useEventRewardList = () => {
    return useQueryBase(['trophyEventRewardList'], fetchEventRewardList, {staleTime: 0});
};

// CSV 프리셋 - gIdx 목록
const fetchMissionPresets = async () => {
    const {data} = await internalApi.get('trophy_challenge/mission_presets');
    return data.gIdxList;
};

export const useMissionPresets = () => {
    return useQueryBase(['trophyMissionPresets'], fetchMissionPresets, {staleTime: 0});
};

// CSV 프리셋 - gIdx별 미션 목록
const fetchMissionPresetByGIdx = async (gIdx) => {
    const {data} = await internalApi.get(`trophy_challenge/mission_presets/${gIdx}`);
    return data.missions;
};

export const useMissionPresetByGIdx = (gIdx) => {
    return useQueryBase(['trophyMissionPresetByGIdx', gIdx], () => fetchMissionPresetByGIdx(gIdx), {
        enabled: !!gIdx,
        staleTime: 0,
    });
};
